import React, { useState, useEffect, useRef, useContext } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import NoiseWebWebp from '../../../../assets/noise/noise-details-banner-desktop.webp';
import NoiseMobileWebp from '../../../../assets/noise/noise-details-banner-mobile.webp';
import './NoiseRideConnected.scss';
import DisFeatureWeb from '../../../../assets/noise/dis-feature-web.webp';
import DisFeatureMobile from '../../../../assets/noise/dis-feature-mobile.webp';
import { pushToDataLayerEvents } from '../../../../dataLayer.js'; // adjust path as needed
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';

const NoiseRideConnected = (props) => {
  const sliderRef = useRef(null);
  const brandName = useContext(LayoutDetailsContext);

  const handleClick = (event, eventCategory, eventAction, eventLabel) => {
    pushToDataLayerEvents({
      event: event,
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel,
      BrandName: 'TVS iQube',
    });
  };
  return (
    <>
      {/* <!--HOme page banner section --> */}
      {/* <div>
        <h1>home page banner section</h1>
        <div className="noise-banner-section" ref={sliderRef}>
          <Slider {...settings}>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
            <div className="always-connected-slider-card">
              <div className="always-connected-slider-image">
                <picture>
                  <source media="(max-width: 768px)" srcSet={NoiseMobileWebp} />
                  <img className="banner-image" src={NoiseWebWebp} alt="Banner" loading="lazy" />
                </picture>
              </div>
            </div>
          </Slider>
        </div>
      </div> */}

      <div id="noise-ride" className="noiseride-section" data-aos="fade-up">
        <div className="noise-ride-container">
          <div className="noise-ride-wrapper">
            <h1 className="noisetitle gotham-medium">
              Once you ride connected, there’s no going back!
            </h1>
            <p className="noisesubtitle gotham-medium">
              You can buy a TVS iQube Noise smartwatch only after purchasing a TVS iQube. Whether
              you’re a new owner or old, grab yours now!
            </p>
          </div>
          <div className="noise-new-custom">
            <div className="noise-custome-common">
              <h3>For New Customers</h3>
              <ol>
                <li>Book your TVS iQube</li>
                <li>Complete the full payment</li>
                <li>Purchase your TVS iQube Noise smartwatch</li>
              </ol>
              <div className="noise-ride-cta">
                <a
                  href="../online-booking"
                  className=""
                  onClick={() =>
                    handleClick(
                      'Book_Online_CTA',
                      'Book Online CTA',
                      'Book iQube',
                      'Popup - For New Customers'
                    )
                  }
                >
                  Book iQube
                </a>
              </div>
            </div>
            <div className="noise-custome-common gotham-medium">
              <h3>For existing TVS iQube owners</h3>
              <ol>
                <li>Login with your registered phone number</li>
                <li>Purchase your TVS iQube Noise smartwatch</li>
              </ol>
              <div className="noise-ride-cta">
                <a
                  href="../login"
                  className=""
                  onClick={() =>
                    handleClick(
                      'Login_Form',
                      'Login Form',
                      'Login',
                      'Popup - For Existing Customers'
                    )
                  }
                >
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(NoiseRideConnected);
